<template>
  <BContainer>
    <h3>Change User</h3>
  </BContainer>
</template>
<script>
export default {
  name: 'ChangeUser'
}
</script>
